import { createAction, props } from '@ngrx/store';
import { Commodity } from '../../models/commodity';

export const commodityEditorSetId = createAction(
    '[Commodity Editor] Set Id',
    props<{ id: string }>()
);

export const commodityEditorSetCommodity = createAction(
    '[Commodity Editor] Set Commodity',
    props<{ commodity: Partial<Commodity> }>()
);

export const commodityEditorLoadRequest = createAction(
    '[Commodity Editor] Load',
    props<{ id: string }>()
);

export const commodityEditorLoadComplete = createAction(
    '[Commodity Editor] Load Complete',
    props<{ commodity: Commodity }>()
);

export const commodityEditorLoadFailure = createAction(
    '[Commodity Editor] Load Failure'
);

export const commodityEditorSaveRequest = createAction(
    '[Commodity Editor] Save Request'
);

export const commodityEditorSaveSuccess = createAction(
    '[Commodity Editor] Save Succeeded'
);

export const commodityEditorSaveFailure = createAction(
    '[Commodity Editor] Save Failure'
);

export const commodityEditorNew = createAction(
    '[Commodity Editor] New'
);
